module.exports = __webpack_public_path__ + "img/f-grow-tree.6bae3c49.svg";